import { routes } from "@/lib/utils/routes";
import { useRouter } from "next/navigation";

export const useBookmarkJob = () => {
  const router = useRouter();

  const onBookmarkJob = async (jobId: string, employeeId?: string) => {
    if (employeeId) {
      // do bookmark with employeeId
    } else {
      router.push(routes.auth.login);
    }
  };

  return {
    onBookmarkJob,
  };
};
